import React, { type ReactNode } from 'react';
import { Layout } from 'antd';
import { Text } from '@g2u/ui-kit';
import styles from './layout.module.scss';
import Geeks2uFooterLogo from 'assets/images/geeks2u-footer-logo.svg';

export namespace SurveyLayout {
  export type SurveyLayoutProps = {
    children: ReactNode;
  };
  export const $: React.FC<SurveyLayoutProps> = ({ children }) => {
    const { Footer, Content } = Layout;
    return (
      <Layout className={styles.surveyLayout}>
        <Content
          className={styles.surveyLayout__content}
          data-testid='survey-content'
        >
          {children}
        </Content>
        <Footer
          className={styles.surveyLayout__footer}
          data-testid='survey-footer'
        >
          <div className={styles.surveyLayout__footerContent}>
            <img
              src={Geeks2uFooterLogo}
              className={styles.surveyLayout__footer__logo}
              alt='Geeks2U'
              data-testid='survey-footer-logo'
            />
            <Text.$
              type='secondary'
              className={styles.surveyLayout__footer__text}
            >
              © Geeks2U Pty Limited | ABN 27 125 370 434
            </Text.$>
          </div>
        </Footer>
      </Layout>
    );
  };
}
